import { Box, styled } from '@mui/material';

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: theme.spacing(6),
  margin: theme.spacing(2, 0),
}));
